import * as React from 'react';

import '../styles.scss';

import { HeadingTextProps } from 'types/textProps';

const SecondaryHeader = (props: HeadingTextProps): React.JSX.Element => {
  const classes =
    `text ${
      props.fontColor}${
      props.italic ? ' --italic' : ''}${
      props.underlined ? ' --underlined' : ''}${
      props.extraClasses ? ` ${props.extraClasses}` : ''
    }`;

  const style = {
    marginTop: props.marginTopPx,
    marginRight: props.marginRightPx,
    marginBottom: props.marginBottomPx,
    marginLeft: props.marginLeftPx,
  };

  return (
    <h2
      className={classes}
      style={style}
    >
      {props.text}
    </h2>
  );
};

export default React.memo(
  SecondaryHeader,
  (prevProps: Readonly<HeadingTextProps>, nextProps: Readonly<HeadingTextProps>) => (
    prevProps.text === nextProps.text
  ),
);
